var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersProfiles02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.4046C17.0561 12.1937 18 14.1804 18 15.4046C18 15.7859 17.7218 16.0951 17.3785 16.0951H17M13 8.17027C13.6832 7.77506 14.1429 7.03638 14.1429 6.19035C14.1429 5.34431 13.6832 4.60563 13 4.21042M2.62148 16.0951H13.569C13.9122 16.0951 14.1905 15.7859 14.1905 15.4046C14.1905 13.0074 12.1878 11.0641 8.09524 11.0641C4.00272 11.0641 2 13.0074 2 15.4046C2 15.7859 2.27824 16.0951 2.62148 16.0951ZM10.381 6.19035C10.381 7.45271 9.3576 8.47606 8.09524 8.47606C6.83287 8.47606 5.80952 7.45271 5.80952 6.19035C5.80952 4.92798 6.83287 3.90463 8.09524 3.90463C9.3576 3.90463 10.381 4.92798 10.381 6.19035Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersProfiles02);
export default __webpack_public_path__ + "static/media/users-profiles-02.8735ca8e9f56d20c9cb8e0707c4a4fc7.svg";
export { ForwardRef as ReactComponent };